/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const tourImageMapType = PropTypes.shape({
    galleryImages: PropTypes.arrayOf(PropTypes.object),
    heroImage: PropTypes.object,
    previewImage: PropTypes.object,
});

export const tourRatingsMapType = PropTypes.shape({
    averageMobileRating: PropTypes.number,
    averageRating: PropTypes.number,
    reviewCount: PropTypes.number,
});

export const feeType = PropTypes.shape({
    unit_price: PropTypes.number,
    per: PropTypes.string,
    units: PropTypes.string,
});

export const pricingByGuestTypeIdType = PropTypes.objectOf(
    PropTypes.shape({
        exists_in_fee_modal: PropTypes.bool,
        guest_type_allowed_by_tour: PropTypes.bool,
        quantity_discount: PropTypes.number,
        ticket_cost: PropTypes.number,
        ticket_required: PropTypes.bool,
    })
);

export const toursType = PropTypes.arrayOf(PropTypes.object);

export const guestTypePType = PropTypes.shape({
    description: PropTypes.string,
    excluded_sales_channels: PropTypes.arrayOf(PropTypes.string),
    guest_type_id: PropTypes.string,
    max_age: PropTypes.number,
    min_age: PropTypes.number,
    pass_type: PropTypes.string,
    ticket_required: PropTypes.bool,
    type: PropTypes.string,
});

export const priceSummaryType = PropTypes.shape({
    total_cost: PropTypes.number,
    previous_payment: PropTypes.number,
    summary_items: PropTypes.arrayOf(
        PropTypes.shape({
            sku: PropTypes.string,
            description: PropTypes.string,
            unit_price: PropTypes.number,
            quantity: PropTypes.number,
        })
    ),
});

export const reservationViewType = PropTypes.shape({
    account_id: PropTypes.string,
    account_type: PropTypes.string,
    addon_tour_id: PropTypes.string,
    contact_email: PropTypes.string,
    contact_name: PropTypes.string,
    contact_phone: PropTypes.string,
    created: PropTypes.string,
    created_by: PropTypes.string,
    facility_id: PropTypes.string,
    internal_account_id: PropTypes.string,
    lottery_application_id: PropTypes.string,
    lottery_instance_id: PropTypes.string,
    order_id: PropTypes.string,
    passes_by_guest_types_id: PropTypes.object,
    payment_method: PropTypes.object,
    purchase_type: PropTypes.string,
    reservation_id: PropTypes.string,
    reservation_number: PropTypes.string,
    sales_category: PropTypes.string,
    sales_channel: PropTypes.string,
    status: PropTypes.string,
    ticket_count_by_guest_type_id: PropTypes.object,
    ticket_count_by_inventory_bucket: PropTypes.object,
    tour_date: PropTypes.string,
    tour_id: PropTypes.string,
    tour_time: PropTypes.string,
});

export const orderDetailsViewType = PropTypes.shape({
    facility_change_cancel_desc: PropTypes.string,
    facility_guest_types: PropTypes.arrayOf(guestTypePType),
    facility_id: PropTypes.string,
    facility_name: PropTypes.string,
    price_summary: priceSummaryType,
    reservation: reservationViewType,
    tour_allowed_guest_type_ids: PropTypes.array,
    tour_duration: PropTypes.string,
    tour_id: PropTypes.string,
    tour_name: PropTypes.string,
    tour_notes: PropTypes.array,
    validation_results: PropTypes.shape({
        required_pass_count_by_guest_type_id: PropTypes.object,
    }),
});

export const facilityAlertsType = PropTypes.arrayOf(
    PropTypes.shape({
        body: PropTypes.string,
        id: PropTypes.string,
    })
);
